import { render, staticRenderFns } from "./DebugWaas.vue?vue&type=template&id=70456905&scoped=true&"
import script from "./DebugWaas.vue?vue&type=script&lang=ts&"
export * from "./DebugWaas.vue?vue&type=script&lang=ts&"
import style0 from "./DebugWaas.vue?vue&type=style&index=0&id=70456905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70456905",
  null
  
)

export default component.exports